// extracted by mini-css-extract-plugin
module.exports = {"container":"_1l88m6g6"};